import { createI18n } from 'vue-i18n';
import ptBR from '@/locales/pt-BR.json';
import en from '@/locales/en.json';
import { getInitialLocale, htmlLangFor } from '@/utils/locale';
import type { LocaleCode } from '@/data/types';

const initialLocale = getInitialLocale();

document.documentElement.lang = htmlLangFor(initialLocale);

export const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: 'pt-BR' as LocaleCode,
  messages: {
    'pt-BR': ptBR,
    en,
  },
});

export function setDocumentLocale(locale: LocaleCode): void {
  document.documentElement.lang = htmlLangFor(locale);
}
